var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ApiClient_accessToken, _ApiClient_client;
import axios from 'axios';
import { SdkError, ApiError, ErrorType } from './error';
import config from './config';
import Debug from './debug';
const debug = Debug('client');
const baseURL = (organization, domain) => {
    return `https://${organization.toLowerCase()}.${domain || config.default.domain}/api`;
};
const handleError = (error) => {
    let sdkError = new SdkError({ message: error.message });
    if (axios.isAxiosError(error)) {
        if (error.response) {
            // The request was made and the server responded with a status code that falls out of the range of 2xx
            const apiError = new ApiError(sdkError);
            apiError.type = ErrorType.RESPONSE;
            apiError.status = error.response.status;
            apiError.code = String(apiError.status);
            apiError.errors = error.response.data.errors;
            sdkError = apiError;
        }
        else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
            sdkError.type = ErrorType.REQUEST;
            sdkError.request = error.request;
        }
        else {
            // Something happened in setting up the request that triggered an Error
            sdkError.type = ErrorType.CLIENT;
        }
    }
    else if (axios.isCancel(error))
        sdkError.type = ErrorType.CANCEL;
    else
        sdkError.source = error;
    throw sdkError;
};
class ApiClient {
    static create(options) {
        for (const attr of config.client.requiredAttributes)
            if (!options || !options[attr])
                throw new SdkError({ message: `Undefined '${attr}' parameter` });
        return new ApiClient(options);
    }
    constructor(options) {
        _ApiClient_accessToken.set(this, void 0);
        _ApiClient_client.set(this, void 0);
        debug('new client instance %O', options);
        this.baseUrl = baseURL(options.organization, options.domain);
        __classPrivateFieldSet(this, _ApiClient_accessToken, options.accessToken, "f");
        const axiosConfig = {
            timeout: options.timeout || config.client.timeout,
            proxy: options.proxy,
            httpAgent: options.httpAgent,
            httpsAgent: options.httpsAgent,
        };
        const axiosOptions = {
            baseURL: this.baseUrl,
            timeout: config.client.timeout,
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
                'Authorization': 'Bearer ' + __classPrivateFieldGet(this, _ApiClient_accessToken, "f"),
            },
            ...axiosConfig
        };
        debug('axios options: %O', axiosOptions);
        __classPrivateFieldSet(this, _ApiClient_client, axios.create(axiosOptions), "f");
        this.interceptors = __classPrivateFieldGet(this, _ApiClient_client, "f").interceptors;
    }
    config(config) {
        debug('config %o', config);
        const def = __classPrivateFieldGet(this, _ApiClient_client, "f").defaults;
        // Axios config
        if (config.timeout)
            def.timeout = config.timeout;
        if (config.proxy)
            def.proxy = config.proxy;
        if (config.httpAgent)
            def.httpAgent = config.httpAgent;
        if (config.httpsAgent)
            def.httpsAgent = config.httpsAgent;
        // API Client config
        if (config.organization)
            this.baseUrl = baseURL(config.organization, config.domain);
        if (config.accessToken) {
            __classPrivateFieldSet(this, _ApiClient_accessToken, config.accessToken, "f");
            def.headers.common.Authorization = 'Bearer ' + __classPrivateFieldGet(this, _ApiClient_accessToken, "f");
        }
    }
    async request(method, path, body, options) {
        debug('request %s %s, %O, %O', method, path, body || {}, options || {});
        const data = body ? { data: body } : undefined;
        const url = path;
        // Runtime request parameters
        const baseUrl = (options === null || options === void 0 ? void 0 : options.organization) ? baseURL(options.organization, options.domain) : undefined;
        const accessToken = (options === null || options === void 0 ? void 0 : options.accessToken) || __classPrivateFieldGet(this, _ApiClient_accessToken, "f");
        const headers = accessToken ? { 'Authorization': 'Bearer ' + accessToken } : undefined;
        const requestParams = { method, baseURL: baseUrl, url, data, headers, ...options };
        debug('request params: %O', requestParams);
        // const start = Date.now()
        return __classPrivateFieldGet(this, _ApiClient_client, "f").request(requestParams)
            .then(response => response.data)
            .catch(error => handleError(error));
        // .finally(() => console.log(`<<-- ${method} ${path} ${Date.now() - start}`))
    }
}
_ApiClient_accessToken = new WeakMap(), _ApiClient_client = new WeakMap();
export default ApiClient;
